import * as Actions from "./_ActionTypes";
import * as Pre from "./_PreActionNames";

export function updateKioskMode(isKioskMode) {
  return {
    type: Actions.IS_KIOSK_MODE,
    payload: { isKioskMode },
  };
}
export function updateAccessToken(accessToken) {
  return {
    type: Pre.APP + Actions.UPDATE_ACCESS_TOKEN,
    payload: { accessToken },
    socket: {
      send: false,
    },
  };
}

export function ResetConnection(newServerUrl) {
  return {
    type: Pre.APP + Actions.RECONNECT,
    payload: { newServerUrl },
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}

export function ForceInit(accessToken = "", buildingId) {
  return {
    type: Actions.FORCE_INIT,
    payload: {
      buildingId,
    },
    socket: {
      send: true,
      keepSocket: true,
    },
    accessToken: accessToken,
  };
}

export function LogOut() {
  return {
    type: Actions.LOGOUT,
    socket: {
      send: false, // keep send = false to handle action locally
      keepSocket: true,
    },
  };
}
export function ShowSplashScreen(isShow = false) {
  return {
    type: Pre.APP + Actions.SHOW_SPLASHSCREEN,
    payload: { isShow },
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}

export function SetScenariosFromCache(scenarios) {
  return {
    type: Pre.SCENARIO + Actions.ALL_CACHE,
    payload: scenarios,
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}
// export function SetQuickAccessFromCache(devices) {
//   return {
//     type: Pre.DEVICE + Actions.ALL_CACHE,
//     payload: devices,
//     socket: {
//       send: false,
//       keepSocket: true,
//     },
//   };
// }

// export function SetAreaStateFromCache(areaStates) {
//   return {
//     type: Pre.AREA + Actions.ALL_CACHE,
//     payload: areaStates,
//     socket: {
//       send: false,
//       keepSocket: true,
//     },
//   };
// }
// === Buildings and Servers ===
export function updateServerUrl(serverUrl) {
  return {
    type: Pre.APP + Actions.UPDATE_SERVER_URL,
    payload: serverUrl,
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}
export function setBuildingList(buildings) {
  return {
    type: Pre.APP + Actions.GET_BUILDING_LIST,
    payload: buildings,
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}
export function setServersList(servers) {
  return {
    type: Pre.APP + Actions.GET_SERVER_LIST,
    payload: servers,
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}
export function setCurrentBuilding(building) {
  return {
    type: Pre.APP + Actions.GET_CURRENT_BUILDING,
    payload: building,
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}

export function setBuildings(buildings) {
  return {
    type: Pre.APP + Actions.SET_BUILDINGS,
    payload: buildings,
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}
export function setServers(servers) {
  return {
    type: Pre.APP + Actions.SET_SERVERS,
    payload: servers,
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}
export function updateCurrentBuilding(building) {
  return {
    type: Pre.APP + Actions.UPDATE_CURRENT_BUILDING,
    payload: building,
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}
export function updateCurrentServer(servers) {
  return {
    type: Pre.APP + Actions.UPDATE_CURRENT_SERVER,
    payload: servers,
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}
export function removerBuilding(buildingId) {
  return {
    type: Pre.APP + Actions.REMOVE_BUILDING,
    payload: buildingId,
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}
export function addServer(serverInfo) {
  return {
    type: Pre.APP + Actions.ADD_SERVER,
    payload: serverInfo,
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}
export function addBuilding(buildingInfo) {
  return {
    type: Pre.APP + Actions.ADD_BUILDING,
    payload: buildingInfo,
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}

// === Notification ===
export function messageToast(message) {
  return {
    type: Pre.APP + Actions.MESSAGE_TOAST,
    payload: message,
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}
export function clearMessageToast() {
  return {
    type: Pre.APP + Actions.CLEAR_MESSAGE_TOAST,
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}
export function clearCache() {
  return {
    type: Actions.CLEAR_CACHE,
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}
// === Widget ===
export function appWidgetAnnouncement(accessToken) {
  return {
    type: Pre.APP_WIDGET + Actions.ANNOUNCEMENT,
    accessToken,
    socket: {
      send: true,
      keep: true,
    },
  };
}
export function clearAnnouncement() {
  return {
    type: Actions.CLEAR_ANNOUNCEMENT,
    socket: {
      send: false,
      keep: true,
    },
  };
}
export function setDoorbellCameraId(cameraId) {
  return {
    type: Actions.SET_CAMERA_ID,
    payload:{
      cameraId
    },
    socket: {
      send: false,
      keep: true,
    },
  };
}
